export default __webpack_public_path__ + "6675b01bb5c8abb55e4c8b554a069700.webp";